import KullaniciList from "./Modules/Kullanicilar/KullaniciList";
export default {
  namespaced: true,
  modules: {
    KullaniciList: KullaniciList,
  },
};
